export const quickButtonsValue = {
  MIN: 'min',
  MAX: 'max',
  '1/2': 'divide',
  2: 'multiply',
  3: 'multiply',
};
